import React, { useState } from 'react'
import DashboardHeader from '../DashboardHeader/DashboardHeader'
import { CopyIcon2, PencilIcon } from '../../Assets/AllSvg'
import { Menu, MenuHandler, MenuItem, MenuList, Tooltip } from '@material-tailwind/react'
import { BsThreeDots } from 'react-icons/bs'
import { AiTwotoneDelete } from 'react-icons/ai'
import { BiPlus } from 'react-icons/bi'

const ShiprateDetail = () => {
    const [options, setOptions] = useState({
        metaData: false
    })

    const handleAddMetadata = () => {
        setOptions({ ...options, metaData: !options.metaData })
    }

    return (
        <div>
            <DashboardHeader />
            <div className="max-w-[1690px] mx-auto sm:p-[40px] p-[20px] w-full text-[#414552]">
                <div className="flex items-center justify-between">
                    <div className='flex items-center gap-2 text-[#687385] text-[13px] cursor-pointer'>
                        <span className='font-medium'>SHIPPING RATE</span>
                    </div>
                    <Tooltip className="bg-gray-800 text-white" content={
                        <div className='flex items-center text-sm gap-1 rounded-sm'>Copy ID <div className="ml-1 flex gap-1 items-center p-[1px_6px] rounded-sm bg-gray-700 text-xs font-normal">ctrl</div>+<div className="ml-1 flex gap-1 items-center p-[1px_6px] rounded-sm bg-gray-700 text-xs font-normal">i</div></div>
                    }>
                        <button className='text-xs text-[#687385] flex items-center gap-1'>shr_1NL0D4SH60np6AHNO6Xgnt9S <CopyIcon2 className="fill-[#687385]" /></button>
                    </Tooltip>
                </div>
                <div className="flex items-center sm:flex-row flex-col gap-2 justify-between mt-1 pb-3 border-b-[1px] border-[#ebeef1]">
                    <div className='flex gap-2 items-center'>
                        <h3 className='text-[#1a1b25] sm:text-[28px] text-[20px] font-bold'>test - $100.00 USD</h3>
                        <div className="text-[#006908] bg-[#d7f7c2] p-[1px_6px] text-xs rounded-md w-max font-medium">Active</div>
                    </div>
                    <div className="flex items-center gap-4">
                        <button className='h-[30px] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-2'>Copy to live mode</button>
                        <Menu placement="bottom-end">
                            <MenuHandler>
                                <button className='input_focus_shadow px-2 py-1 hover:bg-white rounded-md'><BsThreeDots /></button>
                            </MenuHandler>
                            <MenuList className='px-0 py-2 mt-2 min-w-[168px] outline-remove'>
                                <Tooltip placement="left" className="bg-white shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] text-sm text-start p-[16px] w-full max-w-[300px]" content={
                                    <div className='text-sm text-[#414552]'>
                                        Sets the shipping rate as archived. Archived shippingrates cannot be used with new Checkout Sessions, but will still workfor Sessions that already have it set.
                                    </div>
                                }>
                                    <MenuItem className='text-sm font-medium text-[#df1b41] px-[12px] py-1 rounded-none'>
                                        Archive shipping rate</MenuItem>
                                </Tooltip>
                            </MenuList>
                        </Menu>
                    </div>
                </div>
                <div className='flex my-[20px]'>
                    <div className='pr-4 text-sm'>
                        <h3 className='text-[#687385]'>Amount</h3>
                        <p className='text-[#414552] mt-1'>$100.00 USD</p>
                    </div>
                </div>
                <div className="mt-12">
                    <div className="pb-3 border-b-[1px] border-[#ebeef1] flex justify-between items-center">
                        <span className="text-[#30313d] text-[20px] font-bold">Details</span>
                    </div>
                    <div className="grid md:grid-cols-2 grid-cols-1">
                        <div className='p-[12px_0px]'>
                            <div className='flex text-sm sm:justify-start justify-between'>
                                <div className='text-[#687385] sm:max-w-[200px] sm:w-full'>ID</div>
                                <button className='text-xs text-[#687385] flex items-center gap-1'>shr_1NL0D4SH60np6AHNO6Xgnt9S <CopyIcon2 className="fill-[#687385]" /></button>
                            </div>
                            <div className='flex text-sm mt-2 sm:justify-start justify-between'>
                                <div className='text-[#687385] sm:max-w-[200px] sm:w-full'>Description</div>
                                <span className='text-[#414552]'>test</span>
                            </div>
                            <div className='flex text-sm mt-2 sm:justify-start justify-between'>
                                <div className='text-[#687385] sm:max-w-[200px] sm:w-full'>Est. shipping time</div>
                                <span className='text-[#414552]'>Between 1 and 3 days</span>
                            </div>
                            <div className='flex text-sm mt-2 sm:justify-start justify-between'>
                                <div className='text-[#687385] sm:max-w-[200px] sm:w-full'>Created</div>
                                <span className='text-[#414552]'>Jun 20, 2023</span>
                            </div>
                        </div>
                        <div className='p-[12px_0px]'>
                            <div className='flex text-sm sm:justify-start justify-between'>
                                <div className='text-[#687385] sm:max-w-[200px] sm:w-full'>Status</div>
                                <span className='text-[#414552]'>Active</span>
                            </div>
                            <div className='flex text-sm mt-2 sm:justify-start justify-between'>
                                <div className='text-[#687385] sm:max-w-[200px] sm:w-full'>Amount</div>
                                <span className='text-[#414552]'>$100.00 USD</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-12">
                    <div className="pb-3 border-b-[1px] border-[#ebeef1] flex justify-between items-center">
                        <span className="text-[#30313d] text-[20px] font-bold">Metadata</span>
                        <button onClick={handleAddMetadata} disabled={options.metaData ? true : false} className={`${options.metaData && "opacity-60 "} h-[30px] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-2`}><PencilIcon />Edit metadata</button>
                    </div>
                    <div className='mt-3'>
                        {options.metaData ?
                            <div>
                                <div className="w-full flex gap-3 pb-5 border-b-[1px] border-[#ebeef1]">
                                    <input type="text" placeholder="Key" className="input_focus_shadow max-w-[175px] text-[#404552] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]" />
                                    <textarea placeholder="Value" className="input_focus_shadow py-1 text-[#404552] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]" />
                                    <button>
                                        <AiTwotoneDelete className="text-[18px] text-[#625afa]" />
                                    </button>
                                </div>
                                <div className='flex justify-between items-center'>
                                    <button className="sm:first-letter:ml-3 flex items-center gap-1 text-sm font-semibold text-[#625afa]"><BiPlus className='text-[18px]' /> Add custom field</button>
                                    <div className="font-semibold sm:p-[16px_20px] p-[16px_0] flex text-base text-gray-900 gap-2">
                                        <button onClick={handleAddMetadata} className="input_focus_shadow h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px]">Cancel</button>
                                        <button className="border-[2px] h-[30px] rounded-[6px] border-[#625afa] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]">Save</button>
                                    </div>
                                </div>
                            </div> :
                            <p className='text-sm text-[#a3acba]'>No metadata</p>
                        }
                    </div>
                </div>
                <div className="mt-12">
                    <div className="pb-3 border-b-[1px] border-[#ebeef1] flex justify-between items-center">
                        <span className="text-[#30313d] text-[20px] font-bold">Currencies</span>
                    </div>
                    <table className='table-auto ship-rate-table w-full mt-2'>
                        <thead>
                            <tr className='border-b-[1px] border-[#ebeef1] text-[#1a1b25]'>
                                <th className='text-[11px] px-[12px] py-[8px] font-medium text-start w-[30%]'>CURRENCY</th>
                                <th className='text-[11px] px-[12px] py-[8px] font-medium text-start'>AMOUNT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='hover:bg-[#f6f8fa] text-[#1a1b25]'>
                                <td className='px-[12px] py-[8px] text-[13px] cursor-pointer'>AED</td>
                                <td className='px-[12px] py-[8px] text-sm cursor-pointer'>د.إ2,000.00</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default ShiprateDetail